<template>
  <div>
    <div class="is-print-hide">
      <el-table
        stripe
        ref="multipleTable"
        :data="prescriptionList"
        size="medium"
        style="width: 100%"
        :cell-class-name="selectable"
        @selection-change="handleSelectionChange"
        header-row-class-name="common-table-header"
        row-class-name="common-table-row"
        class="is-print-hide common-table"
        :border="true"
      >
        <el-table-column type="selection" width="55" v-if="batchType" :selectable="checkboxT"></el-table-column>
        <!-- 选中打印图片-->
        <el-table-column
          class-name="print-column"
          type="selection"
          width="55"
          v-if="toolBarStatus === 'print'"
          :selectable="canPrint"
        ></el-table-column>

        <el-table-column prop="id" label="处方编号" min-width="90">
          <template slot-scope="scope">
            <div>
              <el-tooltip class="item" effect="dark" :open-delay="500" :content="scope.row.id + ''" placement="top">
                <el-button class="idbtn" @click="checkDetail(scope.row.id)" type="text" size="small">
                  {{ scope.row.id }}
                </el-button>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="name" label="患者姓名" min-width="110">
          <template slot-scope="scope">
            <div>
              <el-tooltip class="item" effect="dark" :open-delay="500" :content="scope.row.name" placement="top">
                <span>{{ scope.row.name }}</span>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="applySourceString" label="处方来源"></el-table-column>
        <el-table-column prop="storeName" v-if="renderName()" label="提交门店" min-width="110">
          <template slot-scope="scope">
            <el-row>
              <el-tooltip class="item" effect="dark" :open-delay="500" :content="scope.row.storeName" placement="top">
                <div class="storeName_div">{{ scope.row.storeName }}</div>
              </el-tooltip>
            </el-row>
          </template>
        </el-table-column>
        <el-table-column prop="userName" label="提交人员" min-width="110">
          <span slot-scope="scope">{{ scope.row.userName }}</span>
        </el-table-column>
        <el-table-column prop="companyName" label="提交公司" min-width="110" v-if="superviseRole">
          <span slot-scope="scope">{{ scope.row.companyName }}</span>
        </el-table-column>
        <!--        <el-table-column prop="userName" label="咨询方式" min-width="110">-->
        <!--          <span slot-scope="scope">{{ scope.row.advisoryType | mapAdvisoryType }}</span>-->
        <!--        </el-table-column>-->
        <el-table-column prop="userName" label="处方类型" min-width="110">
          <span slot-scope="scope">{{ scope.row.prescriptionType | mapPrescriptionType }}</span>
        </el-table-column>
        <!--        <el-table-column prop="relation" label="关联处方" min-width="110">-->
        <!--          <template slot-scope="scope" v-if="scope.row.relation">-->
        <!--            <el-button-->
        <!--              v-for="(subId, index) in scope.row.relation.split(',')"-->
        <!--              @click="checkDetail(subId)"-->
        <!--              type="text"-->
        <!--              size="small"-->
        <!--              :key="index"-->
        <!--            >-->
        <!--              {{ subId }}-->
        <!--            </el-button>-->
        <!--          </template>-->
        <!--        </el-table-column>-->
        <el-table-column
          v-if="!superviseRole"
          prop="prescriptionPredistributionAuditorName"
          label="分配药师"
          min-width="80"
        >
          <template #default="{ row: { prescriptionPredistributionAuditorName, verifyRoleType } }">
            {{ transformAuditorName(prescriptionPredistributionAuditorName, verifyRoleType) }}
          </template>
        </el-table-column>
        <el-table-column prop="prescriptionAuditorName" label="审方药师" min-width="80" v-if="!superviseRole">
          <template #default="{ row: { prescriptionAuditorName, verifyRoleType } }">
            {{ transformAuditorName(prescriptionAuditorName, verifyRoleType) }}
          </template>
        </el-table-column>
        <el-table-column
          v-if="displayConfigShow(displayConfig.dispense)"
          prop="dispenserSign"
          label="调配"
          min-width="80"
        >
          <template slot-scope="scope">
            {{ scope.row.dispenserSign }}
          </template>
        </el-table-column>
        <el-table-column
          v-if="displayConfigShow(displayConfig.dispatch)"
          prop="dispatcherSign"
          label="发药"
          min-width="80"
        >
          <template slot-scope="scope">
            {{ scope.row.dispatcherSign }}
          </template>
        </el-table-column>
        <el-table-column prop="auditPlatformName" label="审方平台" min-width="110" v-if="!superviseRole">
          <template slot-scope="scope">
            {{ scope.row.auditPlatformName ? scope.row.auditPlatformName : '' }}
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="开方时间" min-width="140" v-if="!superviseRole">
          <template slot-scope="scope">
            <!--            {{ scope.row.createTime | parseTime }}-->
            {{ scope.row.doctorAuditTimeStr }}
          </template>
        </el-table-column>
        <el-table-column prop="prescriptionAuditTime" label="审方时间" min-width="140" v-if="!superviseRole">
          <template slot-scope="scope">
            <!--            {{ scope.row.createTime | parseTime }}-->
            {{ scope.row.prescriptionAuditTime | formatDatetime }}
          </template>
        </el-table-column>
        <el-table-column prop="prescriptionTotalStatus" label="状态" min-width="100" v-if="!superviseRole">
          <template slot-scope="scope">
            {{ scope.row.prescriptionTotalStatus | parsePrescriptionStatus }}
          </template>
        </el-table-column>

        <el-table-column label="操作" min-width="140" fixed="right">
          <!-- eslint-disable-next-line vue/no-unused-vars -->
          <template slot="header" slot-scope="scope">
            <div class="hnamecenter">操作</div>
          </template>
          <template slot-scope="scope">
            <el-row>
              <div class="handler">
                <div class="btn global_common_text_hover" @click="goDetail(scope.row)">
                  <span>详情</span>
                </div>
                <div
                  class="btn global_common_text_hover"
                  v-permission.not="'h,i,j'"
                  v-if="printRender(scope)"
                  @click="onPrint(scope.row)"
                >
                  <span>打印</span>
                </div>
                <div
                  class="btn global_common_text_hover"
                  v-permission.not="'h,i,j'"
                  v-if="dropdownItemShow('all', scope.row.prescriptionTotalStatus)"
                >
                  <el-dropdown>
                    <span class="handler_more">更多</span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item
                        v-if="dropdownItemShow('下载', scope.row.prescriptionTotalStatus)"
                        @click.native="download(scope.row.id)"
                      >
                        下载
                      </el-dropdown-item>
                      <el-dropdown-item
                        v-if="dropdownItemShow('下载', scope.row.prescriptionTotalStatus)"
                        @click.native="receiptPrint(scope.row.id)"
                      >
                        打印小票
                      </el-dropdown-item>
                      <el-dropdown-item
                        v-if="hasPermissionPrice('下载', scope.row.prescriptionTotalStatus, scope.row.prescriptionType)"
                        @click.native="handlePrice(scope.row.id)"
                      >
                        划价
                      </el-dropdown-item>
                      <template v-if="!superviseRole">
                        <el-dropdown-item
                          v-if="dropdownItemShow('删除', scope.row.prescriptionTotalStatus)"
                          @click.native="$emit('deleteId', scope.row.id)"
                        >
                          删除
                        </el-dropdown-item>
                      </template>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
              </div>
            </el-row>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog
      class="price-box"
      title="输入药品总价"
      :visible.sync="dialog"
      show-close
      width="500px"
      center
      @closed="dialog = false"
      append-to-body
    >
      <div class="input">
        <el-input
          placeholder="请输入"
          style="width: 156px"
          :max="10000"
          :min="0.01"
          @input="v => handleInput(v)"
          v-model="formData.amount"
        ></el-input>
        元
        <div class="desc">按照药品实际价格输入</div>
      </div>
      <div class="drugList">
        <div class="head">药品信息</div>
        <div v-for="(item, key) in formData.medicationList" :key="key" class="list">
          {{ item.drugName }} {{ item.spec }} 【{{ item.num }}】
        </div>
      </div>
      <div>
        <el-checkbox v-model="formData.isChecked">
          <span class="span">我已阅读并确认</span>
        </el-checkbox>
        <span class="link" @click="handlePageAgreement">《处方笺在线输入药品金额功能知情同意书》</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" plain @click="dialog = false">取 消</el-button>
        <el-button type="primary" @click="confirm" :disabled="!formData.isChecked">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { hasPermission } from '@/util';
import Constant from '@/lib/constant';
import dataMode from '@/components/global/table/noDataMode';
import DownloadModal from '../components/ImageDownloadModal';
import print from '@/components/printImg/index';
import printReceipt from '@/components/printReceipt';
import dayjs from 'dayjs';
import Fetch from '@/api';

const { prescriptionHandlerRule, RoleList: baseRole } = Constant;
let debug = false; // 调试审方
export default {
  name: 'homeHeader',
  props: {
    permission: {
      type: Object,
      default: () => {}
    },
    prescriptionList: {
      type: Array,
      default: () => []
    },
    batchType: null,
    batchIds: {
      type: Array,
      default: () => []
    },
    toolBarStatus: {
      type: String,
      required: true
    },
    printImg: {
      type: Array,
      default: () => []
    },
    fresh: {
      type: Function,
      default: () => {}
    }
  },
  filters: {
    mapAdvisoryType(val) {
      return Constant.advisoryTypes[val];
    },
    mapPrescriptionType(val) {
      return Constant.prescriptionType[val];
    },
    formatDatetime(val) {
      if (val) {
        return dayjs(val).format('YYYY-MM-DD HH:mm:ss');
      }
      return '';
    }
  },
  inject: ['_prescription'],
  components: {
    // eslint-disable-next-line vue/no-unused-components
    dataMode
  },
  computed: {
    ...mapGetters(['superviseRole']),
    displayConfig() {
      return this.$store.getters.getdisplayConfig;
    }
  },
  activated() {},
  watch: {
    prescriptionList() {
      if (!this.prescriptionList) {
        return;
      }
      this.dataModeShow = this.prescriptionList.length == 0;
    },
    batchType(val) {
      this.$refs.multipleTable.clearSelection();
    }
  },
  data() {
    return {
      dataModeShow: false,
      faceBoxShow: false, // 人脸识别蒙层显示
      currentH5Path: '', // 当前处方h5审方地址
      qrcodeShow: false, // 下载app二维码显示
      currentPid: '', // 当前处方id
      formData: {}, // 划价的formData
      dialog: false
    };
  },
  methods: {
    handlePageAgreement() {
      window.open(this.getAgreeMent());
    },
    getAgreeMent() {
      const host = location.host;
      if (/\.qa\.|\d+\.\d+\.|localhost/.test(host)) {
        return `https://itm.qa.91jkys.com/project/agreement-drugstore/#/userKnowAgreement`;
      } else if (/\.pre\./.test(host)) {
        return `https://itm.pre.91jkys.com/project/agreement-drugstore/#/userKnowAgreement`;
      } else {
        return `https://itm.91jkys.com/project/agreement-drugstore/#/userKnowAgreement`;
      }
    },
    handleInput(value) {
      let v = ('' + value).match(/^\d*(\.?\d{0,2})/g)[0] || null;
      if (v >= 10000) {
        v = 9999.99;
      }

      this.formData.amount = v;
    },
    confirm() {
      if (!this.formData.amount || Number(this.formData.amount) <= 0) {
        return this.$message.error('请输入金额');
      }
      Fetch.submitPrice({ ...this.formData }).then(res => {
        this.$message.warning('文件生成中，请1分钟后下载');
        this.dialog = false;
        this.fresh();
      });
    },
    // 复选框
    checkboxT(row, index) {
      const { rule = [] } = this.batchType || {};
      const { prescriptionTotalStatus } = row;
      return rule.includes(prescriptionTotalStatus);
    },
    canPrint(row) {
      const { prescriptionImg, prescriptionAuditStatus } = row;
      let imgs = this.printImg.map(v => v.prescriptionImg);
      if (prescriptionAuditStatus !== 2) return false;
      if (this.printImg.length < 4) return true;
      return imgs.indexOf(prescriptionImg) > -1;
    },
    displayConfigShow(config) {
      // 调配发药展示逻辑 省局看不到调配发药
      let per = [baseRole.a, baseRole.b, baseRole.c, baseRole.d, baseRole.e, baseRole.f];
      if (hasPermission(per) && config) {
        return true;
      }
    },
    //
    isStoreManager() {
      // 是不是店长
      let per = [baseRole.a];
      if (hasPermission(per)) {
        return true;
      }
    },
    dropdownItemShow(type, state) {
      if (type === 'all') {
        return Object.values(prescriptionHandlerRule).some(
          ({ rule, status }) => hasPermission(rule) && status.includes(state)
        );
      }
      const { rule, status } = prescriptionHandlerRule[type];
      return hasPermission(rule) && status.includes(state);
    },
    hasPermissionPrice(type, state, prescriptionType) {
      // prescriptionType 0 西药 1 中药
      return this.dropdownItemShow(type, state) && this.permission.inWhiteList && prescriptionType != 1;
    },
    handlePrice(id) {
      // eslint-disable-next-line no-constant-condition
      if (this.permission.signAgreement == false) {
        if (this.isStoreManager()) {
          this.$confirm('使用电子划价功能前，请先完成签署协议。', '协议签署提醒', {
            confirmButtonClass: 'confirmButton1',
            confirmButtonText: '查看协议',
            cancelButtonClass: 'cancelButton',
            // showCancelButton: false,
            center: true
          }).then(res => {
            this.$router.push('/agreement/1001');
          });
        } else {
          this.$confirm(
            '使用电子划价功能前，请先由公司负责人先完成签署协议（使用划价功能或者协议中心-待签署协议可签署）',
            '协议签署提醒',
            {
              confirmButtonClass: 'confirmButton',
              showCancelButton: false,
              center: true
            }
          );
        }
      } else {
        Fetch.prescriptionDetail({ id }).then(data => {
          const { medicationList, amount } = data;
          this.formData = { medicationList, amount, prescriptionId: id, isChecked: false };
        });
        this.dialog = true;
      }
    },
    goDetail(data) {
      let { id, auditable } = data;
      this.$router.push(`/prescription/detail/${id}?mode=1`);
    },
    // 获取处方h5端详情页
    getDetailPath(id) {
      let host = Util.getItmOrigin();
      return `${host}project/internetDrugstore?login=true&autoInit=true#/prescriptionDesc/${id}`;
    },
    // 继续审方
    continueVerify() {
      this.faceBoxShow = false;
    },
    // 下载app
    downLoadApp() {
      this.qrcodeShow = true;
    },
    search(data) {
      this.$emit('search', data);
    },
    // 审核处方
    verify(callback, context) {
      this.closeDia();
      setTimeout(() => {
        callback.call(context);
      }, 600);
    },
    judgeDrug(data) {
      // 渲染药师审方入口
      if (debug) {
        return true;
      }
      let per = [baseRole.b, baseRole.f];
      if (data.auditable == 1 && hasPermission(per)) {
        return true;
      }
    },
    renderName() {
      // 显示提交门店
      let per = [baseRole.a, baseRole.b, baseRole.c];
      return hasPermission(per);
    },
    printRender(scope) {
      if (scope.row.prescriptionTotalStatus === 2) {
        // 完成的处方才可以打印
        return true;
      }
    },
    checkDetail(id) {
      this.$router.push(`/prescription/detail/${id}?mode=1`);
    },
    // 获取打印图片
    onPrint(item) {
      Fetch.getImgUrlByPrescriptionIdList({ prescriptionIdList: [item.id], colourType: 1 }).then(res => {
        if (res.urlInfoList && res.urlInfoList.length > 0) {
          const source = res.urlInfoList.map(v => ({ ...v, prescriptionImg: v.prescriptionImgUrl }));
          print(source, () => {
            Fetch.print_prescription([item.id]);
          });
        }
        // this.fresh();
      });
    },
    receiptPrint(id) {
      Fetch.getReceiptPrinting({ prescriptionId: id }).then(res => {
        // dropdown 组件对打印样式有影响，延迟触发避开dropdown组件样式影响
        setTimeout(() => printReceipt(res), 500);
      });
    },

    handleSelectionChange(val) {
      if (this.toolBarStatus === 'print') {
        return this.$emit('update:printImg', val);
      } else {
        this.$emit(
          'update:batchIds',
          val.map(v => v.id)
        );
      }
    },
    selectable({ row }) {
      if (row.prescriptionTotalStatus != 2) {
        return 'unselect';
      }
    },
    download(id) {
      DownloadModal.show({
        selectCallback: context => {
          const queryDownload = Object.entries(context.downloadFrom)
            .map(val => val.join('='))
            .join('&');
          this._prescription.downLoadOne(id, queryDownload);
          context.showDownload = false;
          this._prescription.batchIds = [];
        }
      });
    },
    transformAuditorName(auditorName, verifyRoleType) {
      if (verifyRoleType && verifyRoleType == 5) {
        return '线下药师';
      }
      return auditorName;
    }
  }
};
</script>
<style lang="scss" scoped>
@import '~@/style/element-variables';
.handler {
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
  .btn {
    font-size: 12px;
    margin-right: 10px;
    text-align: center;
    cursor: pointer;
    &:last-child {
      margin-right: 0;
    }
  }
  .handler_more {
    font-size: 12px;
    color: $--color-primary;
    &::after {
      content: '';
      display: inline-block;
      border-top: 5px solid $--color-primary;
      border-left: 4px solid transparent;
      border-right: 4px solid transparent;
      margin-left: 4px;
    }
  }
}
.digbox {
  img {
    display: block;
    width: 300px;
    margin: 0 auto;
  }
  p {
    text-align: center;
    font-size: 20px;
    font-weight: 500;
  }
}
.hnamecenter {
  position: relative;
  word-wrap: normal;
  text-overflow: ellipsis;
  display: inline-block;
  vertical-align: middle;
  width: 100%;
  text-align: center;
}
.idbtn {
  color: #1e8dff !important;

  &:hover {
    text-decoration: underline;
    color: rgba(77, 209, 104, 1) !important;
  }
}
</style>
<style lang="scss" scoped>
.price-box {
  /deep/.el-dialog__body {
    padding: 0 77px;
  }
}
.input {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  margin-top: 24px;
  width: 100%;
  .el-input {
    margin-right: 8px;
  }
  .desc {
    margin-top: 8px;
    margin-bottom: 25px;
    font-size: 12px;
    width: 100%;
    text-align: center;
    color: #8c8c8c;
    line-height: 18px;
    position: relative;
    left: -25px;
  }
}
.drugList {
  border-top: 1px solid #eeeeee;
  padding-top: 24px;
  margin-bottom: 28px;
  .head {
    font-size: 14px;
    font-weight: 500;
    color: #353535;
    line-height: 22px;
  }
  .list {
    font-size: 14px;
    font-weight: 400;
    color: #595959;
    line-height: 28px;
  }
}
.span {
  font-size: 12px;
  font-weight: 400;
  color: #adadad;
}
.link {
  cursor: pointer;
  font-size: 12px;
  font-weight: 400;
  color: #4991fd;
}
.storeName_div {
  // overflow: auto !important;
  // white-space: normal !important;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.content-wrapper {
  position: relative;
  height: 600px;
  width: 378px;
  .close {
    position: absolute;
    width: 13px;
    height: 13px;
    top: 12px;
    right: 12px;
    z-index: 2;
  }
  .pre-img {
    iframe {
      height: 544px;
      width: 378px;
      border-radius: 4px;
      padding: 24px 24px 0;
    }
  }

  .face-box {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.95);
    border-radius: 4px;
    z-index: 1;
    text-align: center;
    .title {
      margin: 144px 49px 48px;
      text-align: center;
      font-size: 14px;
      font-weight: bold;
      color: #242424;
      line-height: 24px;
    }
    .btn-box {
      .btn {
        display: block;
        width: 174px;
        height: 40px;
        line-height: 40px;
        margin: 0 auto;
        background: #1e8dff;
        font-size: 14px;
        border-radius: 4px;
        border: 1px solid #1e8dff;
        color: #ffffff;
        &.download {
          margin-top: 16px;
          background: #ffffff;
          color: #1e8dff;
        }
      }
    }
    .download {
      margin-top: 24px;
      .qrcode {
        height: 174px;
        width: 174px;
      }
      .tip {
        margin-top: 8px;
        font-size: 12px;
        color: #707070;
      }
    }
  }
}
/deep/ .common-table-header .print-column .el-checkbox {
  display: none;
}
</style>
